module.exports = __webpack_public_path__ + "img/node.3c1baa04.jpg";